const Highlighted = (info: any) => {
  if (!info.term) return <h3>{info.name}</h3>

  const parts = info.name.split(new RegExp(`(${info.term})`, 'gi'))
  return (
    <h3>
      {parts.map((part, i) => (
        <span
          key={i}
          style={
            part.toLowerCase() === info.term.toLowerCase() ? { backgroundColor: 'lightblue' } : {}
          }
        >
          {part}
        </span>
      ))}
    </h3>
  )
}

export default Highlighted
